import { render } from "./tour-button.vue?vue&type=template&id=182ca384"
import script from "./tour-button.vue?vue&type=script&lang=js"
export * from "./tour-button.vue?vue&type=script&lang=js"

import "./tour-button.vue?vue&type=style&index=0&id=182ca384&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-detail-info/classic/detail-info-header/tour-button.vue'],['render',render],['__file',"tour-button.vue"]])

export default __exports__